import { CctvOffIcon } from './CctvOffIcon';

/**
 * author: Colton Wiscombe
 * id 4B6324CC-D2F7-4CDA-B05F-AC05CA7E238D
 * name cctv-off
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cctv-off.svg
 * tags
 * - Home Automation 
 */
export const ClosedCircuitTelevisionOffIcon = CctvOffIcon;
export default ClosedCircuitTelevisionOffIcon